export enum RecapField {
    Accept = 0,
    Name = 1,
    Sign = 2
}